// Dynamiczne ładowanie stylów i skryptów dla bloków
try {
    // style.scss z /template/blocks/**
    const contextStyles = require.context(
        '../template/blocks',
        true,
        /style\.scss$/
    );

    if (contextStyles && typeof contextStyles.keys === 'function') {
        contextStyles.keys().forEach(key => contextStyles(key));
    }

    // view.js z /template/blocks/**
    const contextFrontScripts = require.context(
        '../template/blocks',
        true,
        /view\.js$/
    );

    if (contextFrontScripts && typeof contextFrontScripts.keys === 'function') {
        contextFrontScripts.keys().forEach(key => contextFrontScripts(key));
    }

    // style.scss z /template/acf-block/**
    // const contextAcfBlockStyles = require.context(
    //     '../template/acf-block/about-us',
    //     true,
    //     /style\.scss$/
    // );
    //
    // if (contextAcfBlockStyles && typeof contextAcfBlockStyles.keys === 'function') {
    //     contextAcfBlockStyles.keys().forEach(key => contextAcfBlockStyles(key));
    // }

} catch (error) {
    console.error('Błąd ładowania bloków:', error);
}
